export const UNIT_WORDS = "words";
export const UNIT_WORD = "word";
export const UNIT_SENTENCES = "sentences";
export const UNIT_SENTENCE = "sentence";
export const UNIT_PARAGRAPHS = "paragraphs";
export const UNIT_PARAGRAPH = "paragraph";
export const UNITS = [
  UNIT_WORDS,
  UNIT_WORD,
  UNIT_SENTENCES,
  UNIT_SENTENCE,
  UNIT_PARAGRAPHS,
  UNIT_PARAGRAPH,
];
export type LoremUnit = "words" | "word" | "sentences" | "sentence" | "paragraphs" | "paragraph";
